module.exports = __webpack_public_path__ + "img/interplan.043af57b.jpg";